module.exports = __webpack_public_path__ + "static/media/hero_small.aff04c7a.png";